import { FC } from 'react';
import { Filter, FiltersProvider } from '../Filters';
import { MealSwap, MealSwapProps } from './MealSwap';

export interface MealSwapWithFiltersProps extends MealSwapProps {
  initialFilters?: Filter[];
}

export const MealSwapWithFilters: FC<MealSwapWithFiltersProps> = ({
  isLoading,
  isSuccess,
  item,
  onSwap,
  onBackClick,
  initialFilters
}) => (
  <FiltersProvider initialFilters={initialFilters}>
    <MealSwap isLoading={isLoading} isSuccess={isSuccess} item={item} onSwap={onSwap} onBackClick={onBackClick} />
  </FiltersProvider>
);

MealSwapWithFilters.defaultProps = {
  initialFilters: [{ name: 'search', value: '' }]
};
